<template lang="pug">
  include /mixins
  +b.participant-document-view(
  )
    +e.content--hovered(@click.prevent='openPdf')
      +e.preview
        +e.img.IMG(
          :src='icon && icon.props.icon'
          v-if='!item.err'
        )
        +b.mask-img--pointer.LABEL(
          :class="{'mask-img--with-bg': item.err}"
        )
          +e.item.IMG(
            v-if='item.err'
            src='/static/img/error.svg'
          )
      +e.name.P {{ item.file.name }}
    +e.close(@click='removeItem(idx)')
      +e.icon.mdi.mdi-close

</template>
<script>

const EXTENTIONS_MAP = {
  'application/pdf': 'PDF',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOC',
  'text/plain': 'TXT',
  'application/msword': 'DOC',
  'application/rtf': 'RTL',
  'application/vnd.oasis.opendocument.text': 'ODT',
}

export default {
  name: 'PdfViewer',
  props: {
    extentions: {
      type: Array,
      default: () => [],
    },
    item: Object,
    idx: Number,
    filekey: { default: 'img' },
    canDelete: { type: Boolean, default: true },
  },
  data() {
    return {
    }
  },
  computed: {
    icon() {
      return (this.extentions || []).find(e => e.caption === EXTENTIONS_MAP[this.item.type]) || (this.extentions || []).find(e => e.is_default)
    },
  },
  methods: {
    getIcon() {
      return (this.extentions || []).find(e => e.caption === EXTENTIONS_MAP[this.item.type]) || (this.extentions || []).find(e => e.is_default)
    },
    removeItem(idx) {
      this.$emit('removeItem', idx)
    },
    openPdf() {
      window.open(this.item[this.filekey], { target: '_blank' });
    },
  },
}
</script>
